module.exports = __webpack_public_path__ + "img/hr-boiler-W-light.ffb22d7c.png";